import { Navigate, Outlet } from 'react-router-dom';
import { useProfile } from '../context/ProfileContext';

export function RequireProfile() {
  const { selectedRole } = useProfile();
  if (!selectedRole) return <Navigate to="/select-profile" replace />;
  return <Outlet />;
}
